// @ts-nocheck
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import SupportInboxMenuIcon from "./SupportInboxMenuIcon";

import LogoutIcon from "../../assets/images/logout.svg";
import { alertDialogAciton, logoutAction } from "../../store/actions/auth";
import "./sidebar.css";

import { Button, IconButton, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  ConfigurationIcon,
  ContractorsIcon,
  ContractsIcon,
  DashboardIcon,
  EventsIcon,
  GenerateQRCodeIcon,
  LogisticsIcon,
  MediaGalleryIcon,
  MessagesIcon,
  PositionsIcon,
  ProfileIcon,
  ReportsIcon,
  SowPoTimesheetIcon,
  UsersIcon,
  BigSearchMenuIcon,
  DepositsMenuIcon,
} from "../../assets/svgs/SVGs";
import { USER_ROLES } from "../../staticData/userRoles";
import { FRONTEND_CONFIG } from "../../utils/constants/configs";
import { isActiveRole, isUserRole } from "../../utils/methods/storeFunc";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { ExpandCircleDownRounded, VerifiedUserOutlined, WorkOutline } from "@mui/icons-material";

const Sidebar = ({
  toggleSideBarData = { open: true },
  setToggleSideBarData,
  accountOnly = false,
}) => {
  const { open } = toggleSideBarData;
  const location = useLocation();
  const navigate = useNavigate();

  // State for all dropdown menus
  const [eventsMenuAnchor, setEventsMenuAnchor] = useState(null);
  const [reportsMenuAnchor, setReportsMenuAnchor] = useState(null);
  const [usersMenuAnchor, setUsersMenuAnchor] = useState(null);
  const [messagesMenuAnchor, setMessagesMenuAnchor] = useState(null);
  const [configurationMenuAnchor, setConfigurationMenuAnchor] = useState(null);

  const dispatch = useDispatch();

  const auth = useSelector((store) => store.auth);
  const { userRole, isSupportAgent } = useSelector((state) => state.auth);
  const groupMessaging = useSelector((store) => store.groupMessaging);
  const oneOnOneMessaging = useSelector((store) => store.oneOnOneMessaging);

  // Helper component for icon with label
  const IconWithLabel = ({ Icon, label, isActive }) => (
    <Box className="main-icon-label-wrapper">
      <Box
        className={`icon-wrapper ${isActive ? "active" : ""}`}
        width={50}
        height={50}
      >
        <Box className="icon-container">
          <Icon size={40} strokeColor={isActive ? "#d175b6" : "#ffffff"} />
        </Box>
      </Box>
      <Typography className="icon-label">{label}</Typography>
    </Box>
  );

  // Helper function to render dropdown menu
  const renderDropdownMenu = (
    anchorEl,
    setAnchorEl,
    menuItems,
    menuStyles = {},
  ) => (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl) && !open}
      onClose={() => setAnchorEl(null)}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      slotProps={{
        paper: {
          onMouseLeave: () => setAnchorEl(null),
        },
      }}
      sx={{
        "& .MuiPaper-root": {
          background: "rgba(20, 20, 40, 0.95)",
          backdropFilter: "blur(10px)",
          border: "1px solid #D175B6",
          borderRadius: "8px",
          boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
          minWidth: "220px",
          overflow: "hidden",
          maxHeight: "none",
          marginLeft: "45px",
          marginTop: "20px",
        },
        "& .MuiMenu-list": {
          maxHeight: "none",
          overflow: "hidden",
        },
        "& .MuiMenuItem-root": {
          color: "#ffffff",
          fontSize: "16px",
          padding: "10px 16px",
          borderBottom: "1px solid rgba(209, 117, 182, 0.2)",
          "&:before": {
            content: '"•"',
            color: "#D175B6",
            marginRight: "8px",
            fontSize: "40px",
            lineHeight: ".5",
            display: "inline-block",
            marginBottom: "4px",
          },
          "&:hover": {
            background: "rgba(209, 117, 182, 0.5)",
            color: "#ffffff",
          },
          "&.active": {
            color: "#D175B6",
          },
          "&:last-child": {
            borderBottom: "none",
          },
        },
        ...menuStyles,
      }}
    >
      {menuItems.map((item, index) => {
        if (!item) return null;
        return (
          <MenuItem
            key={index}
            onClick={() => {
              navigate(item.path);
              setAnchorEl(null);
            }}
            className={item.isActive ? "active" : ""}
          >
            {item.label}
            {item.badge && item.badge > 0 ? (
              <Typography
                variant="span"
                sx={{
                  background: `${getCssVariableHandler({
                    variableName: "--primary-pink-rgb",
                  })} !important`,
                  color: `${getCssVariableHandler({
                    variableName: "--font-rgb",
                  })} !important`,
                  height: "20px",
                  width: "20px",
                  borderRadius: "50%",
                  fontSize: "12px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "8px",
                }}
              >
                {item.badge}
              </Typography>
            ) : null}
          </MenuItem>
        );
      })}
    </Menu>
  );

  // Single source of truth for the "Miscellaneous" submenu, rendered by BOTH the
  // expanded (accordion) and collapsed (popup) modes so they never desync.
  const miscItems = [
    { label: "Text Templates", path: "/configuration/text-templates", visible: true },
    { label: "Safety and non-harassment videos", path: "/configuration/safety-and-non-harassment-videos", visible: true },
    { label: "Tutorial Video", path: "/configuration/tutorial-video", visible: true },
    { label: "Satisfaction Survey", path: "/configuration/satisfaction-survey", visible: true },
    { label: "Support", path: "/configuration/support", visible: isUserRole(USER_ROLES.SUPERADMIN) },
    { label: "Manage Airports", path: "/configuration/airports", visible: true },
    { label: "Event Rate List", path: "/configuration/rate-list", visible: true },
    { label: "Service Agreements", path: "/configuration/service-agreements", visible: true },
    { label: "Onboarding Links", path: "/configuration/contractor-links", visible: isUserRole(USER_ROLES.SUPERADMIN) || Boolean(auth?.addAdpLink) },
    { label: "System Notifications", path: "/configuration/system-notifications", visible: isUserRole(USER_ROLES.SUPERADMIN) },
  ]
    .filter((i) => i.visible)
    .map((i) => ({ ...i, isActive: location.pathname === i.path }));

  return (
    <>
      <Box className={`sidebar-container${open ? "" : "-collapsed"}`}>
        {/* Line */}
        <Box
          sx={{
            cursor: "w-resize",
            display: { sm: "none", lg: "block" },
            position: "absolute",
            top: 0,
            right: -6,
            height: "100%",
            width: "10px",
          }}
          onClick={() =>
            setToggleSideBarData({
              ...toggleSideBarData,
              open: !open,
              priorityOpen: true,
            })
          }
        />
        {/* top button */}
        <Box
          sx={{
            display: { sm: "none", lg: "block" },
            position: "absolute",
            top: 25,
            right: -20,
            rotate: open ? "90deg" : "-90deg",
            transition: "rotate 0.3s ease-in-out",
          }}
        >
          <IconButton
            onClick={() =>
              setToggleSideBarData({
                ...toggleSideBarData,
                open: !open,
                priorityOpen: true,
              })
            }
          >
            <ExpandCircleDownRounded
              sx={{
                color: "#d175b6",
                background: "white",
                borderRadius: "50%",
              }}
            />
          </IconButton>
        </Box>
        {/* bottom button */}
        <Box
          sx={{
            display: { sm: "none", lg: "block" },
            position: "absolute",
            bottom: 75,
            right: -20,
            rotate: open ? "90deg" : "-90deg",
            transition: "rotate 0.3s ease-in-out",
          }}
        >
          <IconButton
            onClick={() =>
              setToggleSideBarData({
                ...toggleSideBarData,
                open: !open,
                priorityOpen: true,
              })
            }
          >
            <ExpandCircleDownRounded
              sx={{
                color: "#d175b6",
                background: "white",
                borderRadius: "50%",
              }}
            />
          </IconButton>
        </Box>
        <Box className="top-routes">
          {accountOnly ? (
            <>
              {[
                {
                  path: "/show-media-gallery",
                  label: "Media Gallery",
                  Icon: MediaGalleryIcon,
                },
                { path: "/profile", label: "Profile", Icon: ProfileIcon },
              ].map(({ path, label, Icon }) => (
                <Box
                  key={path}
                  sx={{
                    "& a": {
                      width: "100%",
                      padding: open ? "16px 20px" : "0px",
                      color: "#fff",
                      fontSize: 20,
                      borderRadius: "8px",
                      border: "1px solid transparent",
                      "&.active": {
                        color: "#D175B6",
                        borderColor: open ? "#D175B6" : "transparent",
                      },
                    },
                  }}
                >
                  <Link
                    to={path}
                    aria-current={location.pathname === path ? "page" : undefined}
                    className={location.pathname === path ? "active" : ""}
                  >
                    {open ? label : (
                      <IconWithLabel
                        Icon={Icon}
                        label={label}
                        isActive={location.pathname === path}
                      />
                    )}
                  </Link>
                </Box>
              ))}
            </>
          ) : (
            <>

          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                marginTop: "20px",
                width: "100%",
                ...(open && {
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                }),
              },
            }}
          >
            <Link
              to="/dashboard"
              className={location.pathname == "/dashboard" ? "active" : ""}
            >
              {open ? (
                "Dashboard"
              ) : (
                <IconWithLabel
                  Icon={DashboardIcon}
                  label="Dashboard"
                  isActive={location.pathname == "/dashboard"}
                />
              )}
            </Link>
          </Box>

          {open && (
            <Accordion className="accordion">
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="accordion-summary"
                sx={{
                  "&.Mui-expanded": {
                    border: "1px solid #D175B6",
                    "& p": {
                      color: "#D175B6",
                    },
                    "& svg": {
                      color: "#D175B6",
                    },
                  },
                }}
              >
                <Typography>Events</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{ overflow: "hidden" }}
                className="accordion-details"
              >
                <Box
                  sx={{
                    "& a": {
                      margin: "4px 0",
                      width: "100%",
                      color: "#ffffff",
                      padding: "8px 14px",
                      borderRadius: "4px",
                      border: "1px solid transparent",
                      position: "relative",
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        width: "12px",
                        height: "81px",
                        borderRadius: "0 0 0 10px",
                        borderBottom: "1px solid #ffffff",
                        borderLeft: "1px solid #ffffff",
                        left: "-13px",
                        bottom: "13px",
                      },
                      "& span": {
                        height: "24px",
                        width: "24px",
                        background: "#FFF",
                        color: "#D175B6",
                        borderRadius: "100%",
                        marginLeft: "5px",
                        lineHeight: "24px",
                        textAlign: "center",
                        display: "inline-block",
                        position: "absolute",
                        right: "9px",
                        top: "5px",
                      },
                      "&.active": {
                        color: "#D175B6",
                        borderColor: "#D175B6",
                        "&:before": {
                          borderBottom: "1px solid #D175B6",
                          borderLeft: "1px solid #D175B6",
                          zIndex: "1",
                        },
                        "& span": {
                          background: "#D175B6",
                          color: "#fff",
                        },
                      },
                    },
                    "& a + a:before": {
                      height: "954px",
                    },
                  }}
                >
                  <Link
                    to="/event/new-requests"
                    className={
                      location.pathname === "/event/new-requests" ||
                      location.pathname.includes("/new-request/details")
                        ? "active"
                        : ""
                    }
                  >
                    New Requests
                  </Link>
                  <Link
                    to="/event/estimates"
                    className={
                      location.pathname === "/event/estimates" ||
                      location.pathname.includes("/estimates/view")
                        ? "active"
                        : ""
                    }
                  >
                    Estimates
                  </Link>
                  <Link
                    to="/event/all-events"
                    className={
                      location.pathname === "/event/all-events" ||
                      location.pathname.includes("/event/details") ||
                      location.pathname.includes("/dashboard/details")
                        ? "active"
                        : ""
                    }
                  >
                    Approved Events
                    {/* <span>9</span> */}
                  </Link>
                  <Link
                    to="/event/partials"
                    className={
                      location.pathname === "/event/partials" ? "active" : ""
                    }
                  >
                    Saved Drafts
                  </Link>

                  <Link
                    to="/event/pre-book-contractors"
                    className={
                      location.pathname === "/event/pre-book-contractors"
                        ? "active"
                        : ""
                    }
                  >
                    Pre Book Contractors
                  </Link>
                </Box>
              </AccordionDetails>
            </Accordion>
          )}
          {!open && (
            <Box
              sx={{
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                ...(open && {
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                }),
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Box
                  component="div"
                  sx={{
                    cursor: "pointer",
                  }}
                  // onClick={() => navigate("/event/new-requests")}
                  onClick={(e) => setEventsMenuAnchor(e.currentTarget)}
                >
                  <IconWithLabel
                    Icon={EventsIcon}
                    label="Events"
                    isActive={
                      location.pathname === "/event/new-requests" ||
                      location.pathname.includes("/event/estimates") ||
                      location.pathname.includes("/event/all-events") ||
                      location.pathname.includes("/event/partials") ||
                      location.pathname.includes("/event/pre-book-contractors")
                    }
                  />
                </Box>
              </Box>

              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  borderRadius: "4px",
                  marginLeft: "6px",
                  transition: "all 0.2s ease",
                }}
              >
                <IconButton
                  size="small"
                  onClick={(e) => setEventsMenuAnchor(e.currentTarget)}
                >
                  <KeyboardArrowDownIcon
                    sx={{
                      color: "#ffffff",
                      fontSize: "30px",
                      transition: "color 0.2s ease",
                      "&:hover": {
                        color: "#D175B6",
                      },
                    }}
                  />
                </IconButton>
              </Box> */}
            </Box>
          )}

          {/* Events Menu Dropdown */}
          {renderDropdownMenu(eventsMenuAnchor, setEventsMenuAnchor, [
            {
              label: "New Requests",
              path: "/event/new-requests",
              isActive:
                location.pathname === "/event/new-requests" ||
                location.pathname.includes("/new-request/details"),
            },
            {
              label: "Estimates",
              path: "/event/estimates",
              isActive:
                location.pathname === "/event/estimates" ||
                location.pathname.includes("/estimates/view"),
            },
            {
              label: "Approved Events",
              path: "/event/all-events",
              isActive:
                location.pathname === "/event/all-events" ||
                location.pathname.includes("/event/details") ||
                location.pathname.includes("/dashboard/details"),
            },
            {
              label: "Saved Drafts",
              path: "/event/partials",
              isActive: location.pathname === "/event/partials",
            },
            {
              label: "Pre Book Contractors",
              path: "/event/pre-book-contractors",
              isActive: location.pathname === "/event/pre-book-contractors",
            },
          ])}

          {open && (
            <Accordion className="accordion">
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="accordion-summary"
                sx={{
                  "&.Mui-expanded": {
                    border: "1px solid #D175B6",
                    "& p": {
                      color: "#D175B6",
                    },
                    "& svg": {
                      color: "#D175B6",
                    },
                  },
                }}
              >
                <Typography>Messages</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{ overflow: "hidden" }}
                className="accordion-details"
              >
                <Box
                  sx={{
                    "& a": {
                      margin: "4px 0",
                      width: "100%",
                      color: "#ffffff",
                      padding: "8px 14px",
                      borderRadius: "4px",
                      border: "1px solid transparent",
                      position: "relative",
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        width: "12px",
                        height: "71px",
                        borderRadius: "0 0 0 10px",
                        borderBottom: "1px solid #ffffff",
                        borderLeft: "1px solid #ffffff",
                        left: "-13px",
                        bottom: "13px",
                      },
                      "& span": {
                        height: "24px",
                        width: "24px",
                        background: "#FFF",
                        color: "#D175B6",
                        borderRadius: "100%",
                        marginLeft: "5px",
                        lineHeight: "24px",
                        textAlign: "center",
                        display: "inline-block",
                        position: "absolute",
                        right: "9px",
                        top: "5px",
                      },
                      "&.active": {
                        color: "#D175B6",
                        borderColor: "#D175B6",
                        "&:before": {
                          borderBottom: "1px solid #D175B6",
                          borderLeft: "1px solid #D175B6",
                          zIndex: "1",
                        },
                        "& span": {
                          background: "#D175B6",
                          color: "#fff",
                        },
                      },
                    },
                    "& a + a:before": {
                      height: "954px",
                    },
                  }}
                >
                  <Link
                    to="/event/chat"
                    className={
                      location.pathname === "/event/chat" ? "active" : ""
                    }
                  >
                    Event Chat
                    {groupMessaging?.unreadChatRoomsCount?.data?.groupCount >
                    0 ? (
                      <Typography
                        variant="span"
                        sx={{
                          background: `${getCssVariableHandler({
                            variableName: "--primary-pink-rgb",
                          })} !important`,
                          color: `${getCssVariableHandler({
                            variableName: "--font-rgb",
                          })} !important`,
                        }}
                      >
                        {groupMessaging?.unreadChatRoomsCount?.data?.groupCount}
                      </Typography>
                    ) : null}
                  </Link>
                  <Link
                    to="/event/chat/admin"
                    className={
                      location.pathname === "/event/chat/admin" ? "active" : ""
                    }
                  >
                    Chat
                    {oneOnOneMessaging?.unreadChatRoomsCount?.data
                      ?.oneOnOneCount > 0 ? (
                      <Typography
                        variant="span"
                        sx={{
                          background: `${getCssVariableHandler({
                            variableName: "--primary-pink-rgb",
                          })} !important`,
                          color: `${getCssVariableHandler({
                            variableName: "--font-rgb",
                          })} !important`,
                        }}
                      >
                        {
                          oneOnOneMessaging?.unreadChatRoomsCount?.data
                            ?.oneOnOneCount
                        }
                      </Typography>
                    ) : null}
                  </Link>
                </Box>
              </AccordionDetails>
            </Accordion>
          )}

          {!open && (
            <Box
              sx={{
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                ...(open && {
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                }),
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Box
                  component="div"
                  sx={{
                    cursor: "pointer",
                  }}
                  // onClick={() => navigate("/event/chat")}
                  onClick={(e) => setMessagesMenuAnchor(e.currentTarget)}
                >
                  <IconWithLabel
                    Icon={MessagesIcon}
                    label="Messages"
                    isActive={location.pathname.includes("/event/chat")}
                  />
                </Box>
              </Box>

              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  borderRadius: "4px",
                  marginLeft: "6px",
                  transition: "all 0.2s ease",
                }}
              >
                <IconButton
                  size="small"
                  onClick={(e) => setMessagesMenuAnchor(e.currentTarget)}
                >
                  <KeyboardArrowDownIcon
                    sx={{
                      color: "#ffffff",
                      fontSize: "30px",
                      transition: "color 0.2s ease",
                      "&:hover": {
                        color: "#D175B6",
                      },
                    }}
                  />
                </IconButton>
              </Box> */}
            </Box>
          )}

          {/* Messages Menu Dropdown */}
          {renderDropdownMenu(messagesMenuAnchor, setMessagesMenuAnchor, [
            {
              label: "Event Chat",
              path: "/event/chat",
              isActive: location.pathname === "/event/chat",
              badge:
                groupMessaging?.unreadChatRoomsCount?.data?.groupCount > 0
                  ? groupMessaging.unreadChatRoomsCount.data.groupCount
                  : 0,
            },
            {
              label: "Chat",
              path: "/event/chat/admin",
              isActive: location.pathname === "/event/chat/admin",
              badge:
                oneOnOneMessaging?.unreadChatRoomsCount?.data?.oneOnOneCount > 0
                  ? oneOnOneMessaging.unreadChatRoomsCount.data.oneOnOneCount
                  : 0,
            },
          ])}

          {/* contracts for admin users */}
          {FRONTEND_CONFIG?.contracts && (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: open ? "16px 20px" : "0px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  ...(open && {
                    ...(open && {
                      "&.active": {
                        border: "1px solid #D175B6",
                        color: "#D175B6",
                      },
                    }),
                  }),
                },
              }}
            >
              <Link
                to="/contracts"
                className={
                  location.pathname == "/contracts" ||
                  location.pathname == "/contract-details"
                    ? "active"
                    : ""
                }
              >
                {open ? (
                  "Contracts"
                ) : (
                  <IconWithLabel
                    Icon={ContractsIcon}
                    label="Contracts"
                    isActive={location.pathname == "/contracts"}
                  />
                )}
              </Link>
            </Box>
          )}

          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                ...(open && {
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                }),
              },
            }}
          >
            <Link
              to="/requested-quote"
              className={
                location.pathname === "/requested-quote" ? "active" : ""
              }
            >
              {open ? (
                "Logistics Quote"
              ) : (
                <IconWithLabel
                  Icon={LogisticsIcon}
                  label="Logistics Quote"
                  isActive={location.pathname == "/requested-quote"}
                />
              )}
            </Link>
          </Box>

          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                ...(open && {
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                }),
              },
            }}
          >
            <Link
              to="/positions"
              className={location.pathname == "/positions" ? "active" : ""}
            >
              {open ? (
                "Positions"
              ) : (
                <IconWithLabel
                  Icon={PositionsIcon}
                  label="Positions"
                  isActive={location.pathname == "/positions"}
                />
              )}
            </Link>
          </Box>
          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                ...(open && {
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                }),
              },
            }}
          >
            <Link
              to="/contractors"
              className={location.pathname == "/contractors" ? "active" : ""}
            >
              {open ? (
                "Contractors"
              ) : (
                <IconWithLabel
                  Icon={ContractorsIcon}
                  label="Contractors"
                  isActive={location.pathname == "/contractors"}
                />
              )}
            </Link>
          </Box>
          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                ...(open && {
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                }),
              },
            }}
          >
            {/* Onboarding (2026-10-08): website sign ups to verify, people waiting for an offer. */}
            <Link
              to="/contractors/verify"
              className={location.pathname == "/contractors/verify" ? "active" : ""}
            >
              {open ? (
                "Verify"
              ) : (
                <IconWithLabel
                  Icon={VerifiedUserOutlined}
                  label="Verify"
                  isActive={location.pathname == "/contractors/verify"}
                />
              )}
            </Link>
          </Box>

          {(isUserRole(USER_ROLES.SUPERADMIN) || auth?.canManageRecruitment) && (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: open ? "16px 20px" : "0px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                },
              }}
            >
              <Link
                to="/recruitment"
                className={location.pathname === "/recruitment" ? "active" : ""}
              >
                {open ? (
                  "Recruitment"
                ) : (
                  <IconWithLabel
                    Icon={WorkOutline}
                    label="Recruitment"
                    isActive={location.pathname === "/recruitment"}
                  />
                )}
              </Link>
            </Box>
          )}
          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                ...(open && {
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                }),
              },
            }}
          >
            <Link
              to="/find-sow"
              className={location.pathname == "/find-sow" ? "active" : ""}
            >
              {open ? (
                "SOW/PO Timesheet"
              ) : (
                <IconWithLabel
                  Icon={SowPoTimesheetIcon}
                  label="SOW/PO Timesheet"
                  isActive={location.pathname == "/find-sow"}
                />
              )}
            </Link>
          </Box>

          {/* Big Search — pessoas <-> eventos (Admin/Super Admin; rota so existe no grupo admin) */}
          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                ...(open && {
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                }),
              },
            }}
          >
            <Link
              to="/big-search"
              className={location.pathname == "/big-search" ? "active" : ""}
            >
              {open ? (
                "Big Search"
              ) : (
                <IconWithLabel
                  Icon={BigSearchMenuIcon}
                  label="Big Search"
                  isActive={location.pathname == "/big-search"}
                />
              )}
            </Link>
          </Box>

          {/* Deposit Invoices tracker — superAdmin or admin with canManageDeposits. */}
          {(isUserRole(USER_ROLES.SUPERADMIN) ||
            (isUserRole(USER_ROLES.ADMIN) && auth?.canManageDeposits)) && (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: open ? "16px 20px" : "0px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                },
              }}
            >
              <Link
                to="/deposits"
                className={location.pathname == "/deposits" ? "active" : ""}
              >
                {open ? (
                  "Deposits"
                ) : (
                  <IconWithLabel
                    Icon={DepositsMenuIcon}
                    label="Deposits"
                    isActive={location.pathname == "/deposits"}
                  />
                )}
              </Link>
            </Box>
          )}

          {isSupportAgent && (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: open ? "16px 20px" : "0px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                },
              }}
            >
              <Link
                to="/support-inbox"
                className={location.pathname == "/support-inbox" ? "active" : ""}
              >
                <SupportInboxMenuIcon
                  open={open}
                  active={location.pathname == "/support-inbox"}
                />
              </Link>
            </Box>
          )}

          {/* Media Gallery = Show Media of every event (the legacy gallery is off). */}
          {isActiveRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN) && (
            <Box
              sx={{
                "& a": {
                  background: "transparent",
                  minHeight: "auto !important",
                  padding: open ? "16px 20px" : "0px",
                  color: "#ffffff",
                  fontSize: "20px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  width: "100%",
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                },
              }}
            >
              <Link
                to="/show-media-gallery"
                className={
                  location.pathname == "/show-media-gallery" ? "active" : ""
                }
              >
                {open ? (
                  "Media Gallery"
                ) : (
                  <IconWithLabel
                    Icon={MediaGalleryIcon}
                    label="Media Gallery"
                    isActive={location.pathname == "/show-media-gallery"}
                  />
                )}
              </Link>
            </Box>
          )}

          {/* Reports */}
          {open && (
            <Accordion className="accordion">
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />}
                aria-controls="panel-reports-content"
                id="panel-reports-header"
                className="accordion-summary"
                sx={{
                  "&.Mui-expanded": {
                    border: "1px solid #D175B6",
                    "& p": {
                      color: "#D175B6",
                    },
                    "& svg": {
                      color: "#D175B6",
                    },
                  },
                }}
              >
                <Typography>Reports</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{ overflow: "hidden" }}
                className="accordion-details"
              >
                <Box
                  sx={{
                    "& a": {
                      margin: "4px 0",
                      width: "100%",
                      color: "#ffffff",
                      padding: "8px 14px",
                      borderRadius: "4px",
                      border: "1px solid transparent",
                      position: "relative",
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        width: "12px",
                        height: "81px",
                        borderRadius: "0 0 0 10px",
                        borderBottom: "1px solid #ffffff",
                        borderLeft: "1px solid #ffffff",
                        left: "-13px",
                        bottom: "13px",
                      },
                      "&.active": {
                        color: "#D175B6",
                        borderColor: "#D175B6",
                        "&:before": {
                          borderBottom: "1px solid #D175B6",
                          borderLeft: "1px solid #D175B6",
                          zIndex: "1",
                        },
                      },
                    },
                    "& a + a:before": {
                      height: "954px",
                    },
                  }}
                >
                  <Link
                    to="/reports/contractor-work"
                    className={
                      location.pathname === "/reports/contractor-work"
                        ? "active"
                        : ""
                    }
                  >
                    Contractor Work Report
                  </Link>
                  <Link
                    to="/reports/assigned-by-users"
                    className={
                      location.pathname === "/reports/assigned-by-users"
                        ? "active"
                        : ""
                    }
                  >
                    Assigned By Users Report
                  </Link>
                  {FRONTEND_CONFIG.revenueReport && (
                    <Link
                      to="/reports/revenue"
                      className={
                        location.pathname === "/reports/revenue" ? "active" : ""
                      }
                    >
                      Revenue Report
                    </Link>
                  )}
                  {FRONTEND_CONFIG.payrollReport && (
                    <Link
                      to="/reports/payroll"
                      className={
                        location.pathname === "/reports/payroll" ? "active" : ""
                      }
                    >
                      Payroll Report
                    </Link>
                  )}
                  {isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN) && (
                    <Link
                      to="/reports/commissions"
                      className={
                        location.pathname === "/reports/commissions"
                          ? "active"
                          : ""
                      }
                    >
                      Coordinator Commissions
                    </Link>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          )}
          {!open && (
            <Box
              sx={{
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                ...(open && {
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                }),
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Box
                  component="div"
                  sx={{
                    cursor: "pointer",
                  }}
                  // onClick={() => navigate("/reports/contractor-work")}
                  onClick={(e) => setReportsMenuAnchor(e.currentTarget)}
                >
                  <IconWithLabel
                    Icon={ReportsIcon}
                    label="Reports"
                    isActive={location.pathname.includes("/reports/")}
                  />
                </Box>
              </Box>

              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  borderRadius: "4px",
                  marginLeft: "6px",
                  transition: "all 0.2s ease",
                }}
              >
                <IconButton
                  size="small"
                  onClick={(e) => setReportsMenuAnchor(e.currentTarget)}
                >
                  <KeyboardArrowDownIcon
                    sx={{
                      color: "#ffffff",
                      fontSize: "30px",
                      transition: "color 0.2s ease",
                      "&:hover": {
                        color: "#D175B6",
                      },
                    }}
                  />
                </IconButton>
              </Box> */}
            </Box>
          )}

          {/* Reports Menu Dropdown */}
          {renderDropdownMenu(reportsMenuAnchor, setReportsMenuAnchor, [
            {
              label: "Contractor Work Report",
              path: "/reports/contractor-work",
              isActive: location.pathname === "/reports/contractor-work",
            },
            {
              label: "Assigned By Users Report",
              path: "/reports/assigned-by-users",
              isActive: location.pathname === "/reports/assigned-by-users",
            },
            ...(FRONTEND_CONFIG.revenueReport
              ? [
                  {
                    label: "Revenue Report",
                    path: "/reports/revenue",
                    isActive: location.pathname === "/reports/revenue",
                  },
                ]
              : []),
            ...(FRONTEND_CONFIG.payrollReport
              ? [
                  {
                    label: "Payroll Report",
                    path: "/reports/payroll",
                    isActive: location.pathname === "/reports/payroll",
                  },
                ]
              : []),
            ...(isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)
              ? [
                  {
                    label: "Coordinator Commissions",
                    path: "/reports/commissions",
                    isActive:
                      location.pathname === "/reports/commissions",
                  },
                ]
              : []),
          ])}

          {open && (
            <Accordion
              sx={{
                background: "transparent",
                boxShadow: "none",
              }}
            >
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />}
                aria-controls="panel2-content"
                id="panel2-header"
                sx={{
                  background: "transparent",
                  color: "primary",
                  minHeight: "auto !important",
                  padding: open ? "16px 20px" : "0px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  "&.Mui-expanded": {
                    border: "1px solid #D175B6",
                    "& p": {
                      color: "#D175B6",
                    },
                    "& svg": {
                      color: "#D175B6",
                    },
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "0 !important",
                    fontSize: "20px",
                    "& p": {
                      fontSize: "20px",
                    },
                  },
                }}
              >
                <Typography>Users</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  padding: "0 0 0 46px",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    "& a": {
                      margin: "4px 0",
                      width: "100%",
                      color: "#ffffff",
                      padding: "8px 14px",
                      borderRadius: "4px",
                      border: "1px solid transparent",
                      position: "relative",
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        width: "12px",
                        height: "81px",
                        borderRadius: "0 0 0 10px",
                        borderBottom: "1px solid #ffffff",
                        borderLeft: "1px solid #ffffff",
                        left: "-13px",
                        bottom: "13px",
                      },
                      "& span": {
                        height: "24px",
                        width: "24px",
                        background: "#FFF",
                        color: "#D175B6",
                        borderRadius: "100%",
                        marginLeft: "5px",
                        lineHeight: "24px",
                        textAlign: "center",
                        display: "inline-block",
                        position: "absolute",
                        right: "9px",
                        top: "5px",
                      },
                      "&.active": {
                        color: "#D175B6",
                        borderColor: "#D175B6",
                        "&:before": {
                          borderBottom: "1px solid #D175B6",
                          borderLeft: "1px solid #D175B6",
                          zIndex: "1",
                        },
                        "& span": {
                          background: "#D175B6",
                          color: "#fff",
                        },
                      },
                    },
                    "& a + a:before": {
                      height: "954px",
                    },
                  }}
                >
                  {isUserRole(USER_ROLES.SUPERADMIN) ? (
                    <Link
                      to="/users/all"
                      className={
                        location.pathname == "/users/all" ? "active" : ""
                      }
                    >
                      All Users
                    </Link>
                  ) : null}
                  {isUserRole(USER_ROLES.SUPERADMIN) ? (
                    <Link
                      to="/users/admins"
                      className={
                        location.pathname == "/users/admins" ? "active" : ""
                      }
                    >
                      Admins
                    </Link>
                  ) : null}
                  {isUserRole(USER_ROLES.SUPERADMIN) && (
                    <Link to="/users/marketing" className={location.pathname === "/users/marketing" ? "active" : ""}>Marketing</Link>
                  )}
                  <Link
                    to="/users/clients "
                    className={
                      location.pathname == "/users/clients" ? "active" : ""
                    }
                  >
                    Clients
                  </Link>

                  <Link
                    to="/users/coordinators"
                    className={
                      location.pathname == "/users/coordinators" ? "active" : ""
                    }
                  >
                    Coordinators
                  </Link>
                  <Link
                    to="/users/freelance"
                    className={
                      location.pathname == "/users/freelance" ? "active" : ""
                    }
                  >
                    Freelance EC
                  </Link>
                  {isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN) && (
                    <Link
                      to="/users/deleted"
                      className={
                        location.pathname == "/users/deleted" ? "active" : ""
                      }
                    >
                      Deleted Users
                    </Link>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          )}
          {!open && (
            <Box
              sx={{
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                ...(open && {
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                }),
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Box
                  component="div"
                  sx={{
                    cursor: "pointer",
                  }}
                  // onClick={() => navigate("/users/admins")}
                  onClick={(e) => setUsersMenuAnchor(e.currentTarget)}
                >
                  <IconWithLabel
                    Icon={UsersIcon}
                    label="Users"
                    isActive={location.pathname.includes("/users/")}
                  />
                </Box>
              </Box>

              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  borderRadius: "4px",
                  marginLeft: "6px",
                  transition: "all 0.2s ease",
                }}
              >
                <IconButton
                  size="small"
                  onClick={(e) => setUsersMenuAnchor(e.currentTarget)}
                >
                  <KeyboardArrowDownIcon
                    sx={{
                      color: "#ffffff",
                      fontSize: "30px",
                      transition: "color 0.2s ease",
                      "&:hover": {
                        color: "#D175B6",
                      },
                    }}
                  />
                </IconButton>
              </Box> */}
            </Box>
          )}

          {/* Users Menu Dropdown */}
          {renderDropdownMenu(usersMenuAnchor, setUsersMenuAnchor, [
            ...(isUserRole(USER_ROLES.SUPERADMIN)
              ? [
                  {
                    label: "All Users",
                    path: "/users/all",
                    isActive: location.pathname == "/users/all",
                  },
                ]
              : []),
            ...(isUserRole(USER_ROLES.SUPERADMIN)
              ? [
                  {
                    label: "Admins",
                    path: "/users/admins",
                    isActive: location.pathname == "/users/admins",
                  },
                  {
                    label: "Marketing",
                    path: "/users/marketing",
                    isActive: location.pathname === "/users/marketing",
                  },
                ]
              : []),
            {
              label: "Clients",
              path: "/users/clients",
              isActive: location.pathname == "/users/clients",
            },
            {
              label: "Coordinators",
              path: "/users/coordinators",
              isActive: location.pathname == "/users/coordinators",
            },
            {
              label: "Freelance EC",
              path: "/users/freelance",
              isActive: location.pathname == "/users/freelance",
            },
            ...(isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)
              ? [
                  {
                    label: "Deleted Users",
                    path: "/users/deleted",
                    isActive: location.pathname == "/users/deleted",
                  },
                ]
              : []),
          ])}

          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                ...(open && {
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                }),
              },
            }}
          >
            <Link
              to="/generate-qr"
              className={location.pathname == "/generate-qr" ? "active" : ""}
            >
              {open ? (
                "Generate QR Code"
              ) : (
                <IconWithLabel
                  Icon={GenerateQRCodeIcon}
                  label="Generate QR"
                  isActive={location.pathname == "/generate-qr"}
                />
              )}
            </Link>
          </Box>

          <Box
            sx={{
              "& a": {
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                ...(open && {
                  ...(open && {
                    "&.active": {
                      border: "1px solid #D175B6",
                      color: "#D175B6",
                    },
                  }),
                }),
              },
            }}
          >
            <Link
              to="/profile"
              className={location.pathname == "/profile" ? "active" : ""}
            >
              {open ? (
                "Profile"
              ) : (
                <IconWithLabel
                  Icon={ProfileIcon}
                  label="Profile"
                  isActive={location.pathname == "/profile"}
                />
              )}
            </Link>
          </Box>

          {open && (
            <Accordion
              sx={{
                background: "transparent",
                boxShadow: "none",
              }}
            >
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon sx={{ color: "#ffffff" }} />}
                aria-controls="panel2-content"
                id="panel2-header"
                sx={{
                  background: "transparent",
                  color: "primary",
                  minHeight: "auto !important",
                  padding: open ? "16px 20px" : "0px",
                  border: "1px solid transparent",
                  borderRadius: "8px",
                  "&.Mui-expanded": {
                    border: "1px solid #D175B6",
                    "& p": {
                      color: "#D175B6",
                    },
                    "& svg": {
                      color: "#D175B6",
                    },
                  },
                  "& .MuiAccordionSummary-content": {
                    margin: "0 !important",
                    fontSize: "20px",
                    "& p": {
                      fontSize: "20px",
                    },
                  },
                }}
              >
                <Typography>Miscellaneous</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  padding: "0 0 0 46px",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    "& a": {
                      margin: "4px 0",
                      width: "100%",
                      color: "#ffffff",
                      padding: "8px 14px",
                      borderRadius: "4px",
                      border: "1px solid transparent",
                      position: "relative",
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        width: "12px",
                        height: "71px",
                        borderRadius: "0 0 0 10px",
                        borderBottom: "1px solid #ffffff",
                        borderLeft: "1px solid #ffffff",
                        left: "-13px",
                        bottom: "13px",
                      },
                      "& span": {
                        height: "24px",
                        width: "24px",
                        background: "#FFF",
                        color: "#D175B6",
                        borderRadius: "100%",
                        marginLeft: "5px",
                        lineHeight: "24px",
                        textAlign: "center",
                        display: "inline-block",
                        position: "absolute",
                        right: "9px",
                        top: "5px",
                      },
                      "&.active": {
                        color: "#D175B6",
                        borderColor: "#D175B6",
                        "&:before": {
                          borderBottom: "1px solid #D175B6",
                          borderLeft: "1px solid #D175B6",
                          zIndex: "1",
                        },
                        "& span": {
                          background: "#D175B6",
                          color: "#fff",
                        },
                      },
                    },
                    "& a + a:before": {
                      height: "954px",
                    },
                  }}
                >
                  {miscItems.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={item.isActive ? "active" : ""}
                    >
                      {item.label}
                    </Link>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
          )}

          {!open && (
            <Box
              sx={{
                background: "transparent",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "20px",
                border: "1px solid transparent",
                borderRadius: "8px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                ...(open && {
                  "&.active": {
                    border: "1px solid #D175B6",
                    color: "#D175B6",
                  },
                }),
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Box
                  component="div"
                  sx={{
                    cursor: "pointer",
                  }}
                  // onClick={() => navigate("/configuration/text-templates")}
                  onClick={(e) => setConfigurationMenuAnchor(e.currentTarget)}
                >
                  <IconWithLabel
                    Icon={ConfigurationIcon}
                    label="Miscellaneous"
                    isActive={location.pathname.includes("/configuration/")}
                  />
                </Box>
              </Box>

              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  borderRadius: "4px",
                  marginLeft: "6px",
                  transition: "all 0.2s ease",
                }}
              >
                <IconButton
                  size="small"
                  onClick={(e) => setConfigurationMenuAnchor(e.currentTarget)}
                >
                  <KeyboardArrowDownIcon
                    sx={{
                      color: "#ffffff",
                      fontSize: "30px",
                      transition: "color 0.2s ease",
                      "&:hover": {
                        color: "#D175B6",
                      },
                    }}
                  />
                </IconButton>
              </Box> */}
            </Box>
          )}

          {/* Configuration Menu Dropdown */}
          {renderDropdownMenu(
            configurationMenuAnchor,
            setConfigurationMenuAnchor,
            miscItems,
          )}
            </>
          )}
        </Box>
        {open ? (
          <Box>
            <Button
              sx={{
                background: "#000000",
                minHeight: "auto !important",
                padding: open ? "16px 20px" : "0px",
                color: "#ffffff",
                fontSize: "16px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
                justifyContent: "center",
                cursor: "pointer",
                width: "100%",
                "& img": {
                  marginRight: "15px",
                },
                "&:hover": {
                  background: "#000000",
                  minHeight: "auto !important",
                  padding: open ? "16px 20px" : "0px",
                  color: "#ffffff",
                  fontSize: "16px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  boxShadow: "0px 0px 30px 0px rgba(209, 117, 182, 0.20)",
                  justifyContent: "center",
                  cursor: "pointer",
                  width: "100%",
                  "& img": {
                    marginRight: "15px",
                  },
                },
              }}
              onClick={(e) => {
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Confirm Logout",
                    message: "Are you sure, you want to logout?",
                    onOk: () => {
                      dispatch(logoutAction({}));
                      navigate("/login");
                    },
                    okLabel: "Logout",
                    closeLabel: "Stay Logged In",
                  }),
                );
              }}
            >
              <img src={LogoutIcon} />
              Logout
            </Button>
          </Box>
        ) : (
          <IconButton
            aria-label="Logout"
            onClick={(e) => {
              dispatch(logoutAction({}));
              navigate("/login");
            }}
          >
            <img src={LogoutIcon} className="logout-button-icon" />
          </IconButton>
        )}
      </Box>
    </>
  );
};

export default Sidebar;
